import { BarcodeFormat } from '@zxing/library'

export type DetectedBarcode = {
  rawValue: string
  format: string
}

export type ZxingScanResultLike = {
  getText: () => string
  getBarcodeFormat: () => BarcodeFormat
}

const ZXING_FORMAT_TO_BARCODE_DETECTOR_FORMAT: Partial<Record<BarcodeFormat, string>> = {
  [BarcodeFormat.AZTEC]: 'aztec',
  [BarcodeFormat.CODABAR]: 'codabar',
  [BarcodeFormat.CODE_39]: 'code_39',
  [BarcodeFormat.CODE_93]: 'code_93',
  [BarcodeFormat.CODE_128]: 'code_128',
  [BarcodeFormat.DATA_MATRIX]: 'data_matrix',
  [BarcodeFormat.EAN_8]: 'ean_8',
  [BarcodeFormat.EAN_13]: 'ean_13',
  [BarcodeFormat.ITF]: 'itf',
  [BarcodeFormat.MAXICODE]: 'maxicode',
  [BarcodeFormat.PDF_417]: 'pdf417',
  [BarcodeFormat.QR_CODE]: 'qr_code',
  [BarcodeFormat.RSS_14]: 'rss_14',
  [BarcodeFormat.RSS_EXPANDED]: 'rss_expanded',
  [BarcodeFormat.UPC_A]: 'upc_a',
  [BarcodeFormat.UPC_E]: 'upc_e',
  [BarcodeFormat.UPC_EAN_EXTENSION]: 'upc_ean_extension',
}

export const normalizeZxingBarcodeFormat = (format: BarcodeFormat): string => {
  return ZXING_FORMAT_TO_BARCODE_DETECTOR_FORMAT[format] ?? BarcodeFormat[format]?.toLowerCase() ?? ''
}

export const normalizeZxingScanResult = (
  result: ZxingScanResultLike | undefined,
): DetectedBarcode | null => {
  const rawValue = result?.getText()?.trim()

  if (!rawValue) {
    return null
  }

  return {
    rawValue,
    format: normalizeZxingBarcodeFormat(result.getBarcodeFormat()),
  }
}

export const findPreferredBarcode = (
  detectedCodes: DetectedBarcode[] = [],
  preferredFormats: string[] = [],
): DetectedBarcode | undefined => {
  const preferredFormatSet = new Set(preferredFormats)

  return (
    detectedCodes.find((code) => preferredFormatSet.has(code.format) && code.rawValue) ||
    detectedCodes.find((code) => code.rawValue)
  )
}
